import React from 'react';
import { CircularProgress, Box } from '@mui/material';
import { useLoading } from '../context';

interface LoadingOverlayProps {
  open?: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ open: propsOpen }) => {
  const { isLoading } = useLoading();

  // Use the prop if provided, otherwise use the context value
  const open = propsOpen ?? isLoading;

  if (!open) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: theme => theme.zIndex.drawer + 1,
        pointerEvents: 'auto', // Block interactions with elements behind
      }}
    >
      <CircularProgress color="primary" />
    </Box>
  );
};

export default LoadingOverlay;
